/*
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-03-12 20:07:09
 * @FilePath: /insuranceagent-ui/src/util/eventBus.js
 * @Description:
 */
import Vue from 'vue'

export const EventBus = new Vue()
const eventBusKey = {
	updateVersion: 'updateVersion',
	BusPolicyPdfDownload: 'busPolicyPdfDownload',
}

export default eventBusKey
